function getSettings() {
  try {
    if (typeof Office === "undefined" || !Office.context || !Office.context.document) {
      return null;
    }
    return Office.context.document.settings || null;
  } catch (error) {
    return null;
  }
}

export function initializeOffice() {
  return new Promise((resolve) => {
    if (typeof Office === "undefined" || typeof Office.onReady !== "function") {
      resolve(null);
      return;
    }

    Office.onReady((info) => {
      resolve(info || null);
    });
  });
}

export function loadSetting(key) {
  const settings = getSettings();
  if (!settings) {
    return null;
  }

  const value = settings.get(key);
  if (value === null || value === undefined || value === "") {
    return null;
  }
  return value;
}

export function saveSetting(key, value) {
  return new Promise((resolve) => {
    const settings = getSettings();
    if (!settings) {
      resolve(false);
      return;
    }

    settings.set(key, value);
    settings.saveAsync((result) => {
      resolve(result.status === Office.AsyncResultStatus.Succeeded);
    });
  });
}
